/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractInvoicingModeResource } from './';
import {
    ContractInvoicingModeResourceFromJSON,
    ContractInvoicingModeResourceFromJSONTyped,
    ContractInvoicingModeResourceToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';
import type { ProjectClientTermsResource } from './';
import {
    ProjectClientTermsResourceFromJSON,
    ProjectClientTermsResourceFromJSONTyped,
    ProjectClientTermsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractDirectModeResource
 */
export interface ContractDirectModeResource extends ContractInvoicingModeResource {
    /**
     * 
     * @type {ProjectClientTermsResource}
     * @memberof ContractDirectModeResource
     */
    clientTerms?: ProjectClientTermsResource;
}

/**
 * Check if a given object implements the ContractDirectModeResource interface.
 */
export function instanceOfContractDirectModeResource(value: object): value is ContractDirectModeResource {
    return true;
}

export function ContractDirectModeResourceFromJSON(json: any): ContractDirectModeResource {
    return ContractDirectModeResourceFromJSONTyped(json, false);
}

export function ContractDirectModeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractDirectModeResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ContractInvoicingModeResourceFromJSONTyped(json, ignoreDiscriminator),
        'clientTerms': json['clientTerms'] == null ? undefined : ProjectClientTermsResourceFromJSON(json['clientTerms']),
    };
}

export function ContractDirectModeResourceToJSON(value?: ContractDirectModeResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ContractInvoicingModeResourceToJSON(value, true),
        'clientTerms': ProjectClientTermsResourceToJSON(value['clientTerms']),
    };
}

